import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FlightLogsRoutingModule } from '@flyfreely-portal-ui/flight-logs';
import { FEATURE_DYNAMIC_REPORTING } from '@flyfreely-portal-ui/flyfreely';
import { OrganisationAdminRoutingModule } from '@flyfreely-portal-ui/organisation-admin';
import { AccountPermissionsGuard } from '@flyfreely-portal-ui/ui';
import { UserProfileRoutingModule } from '@flyfreely-portal-ui/user-profile';
import { FeatureFlagGuard } from 'libs/ui/src/lib/router-guards/featureFlag.guard';
import { ReportSideBarComponent } from '../report-side-bar/report-side-bar.component';
import { ReportViewComponent } from '../report-view/report-view.component';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        RouterModule.forChild([
            {
                path: '',
                component: ReportViewComponent,
                canActivate: [FeatureFlagGuard, AccountPermissionsGuard],
                data: { requiredFeatureFlag: FEATURE_DYNAMIC_REPORTING },
                runGuardsAndResolvers: 'always',
                children: [
                    {
                        path: 'flightlogs',
                        loadChildren: () => FlightLogsRoutingModule
                    },
                    {
                        path: 'orgadmin',
                        loadChildren: () => OrganisationAdminRoutingModule
                    },
                    {
                        path: 'userprofile',
                        loadChildren: () => UserProfileRoutingModule
                    }
                ]
            },
            {
                path: '',
                component: ReportSideBarComponent,
                outlet: 'sidebar'
            }
        ])
    ],
    exports: [RouterModule]
})
export class ReportingRoutingModule {}
